// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"268":"Home","313":"Details","419":"InfoCenter","797":"Iframe","842":"List","845":"LiveRoom"}[chunkId] || chunkId) + "." + {"268":"6d64f58e","313":"6ed4cae2","419":"ec47b699","440":"f687ae41","492":"4378ee45","797":"76c875f3","842":"4688a5c8","845":"5864ae19"}[chunkId] + ".js";
};